import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';

export const contentTime = value => {
    const date = typeof value?.toDate === 'function' ? value.toDate() : new Date(value || 0);
    return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};
export default function useContent(db, appId, name) {
    const [state, setState] = useState({ items: [], loading: true });
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        setState({ items: [], loading: true });
        if (!db || !appId) {
            setState({ items: [], error: true });
            return;
        }
        return onSnapshot(collection(db, `/artifacts/${appId}/public/data/${name}`), snapshot => {
            const items = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            items.sort((a, b) => contentTime(b.createdAt) - contentTime(a.createdAt));
            setState({ items, loading: false });
        }, () => setState({ items: [], error: true }));
    }, [db, appId, name, attempt]);
    return { ...state, retry: () => setAttempt(n => n + 1) };
}
